// extracted by mini-css-extract-plugin
export default {"container":"Body_container__9lUqe"};